import { action, computed, observable } from 'mobx'
import { JtechStore } from 'src/plugins/mobx'

export default class GenerateOrderState {
    @observable actualBatchInfos = {};

    static getInstance () {
      return JtechStore.getSingleton('generateOrderState', new GenerateOrderState())
    }

    @action.bound setActualBatchInfos (actualBatchInfos) {
      this.actualBatchInfos = actualBatchInfos
    }
}
